export default __webpack_public_path__ + "static/media/hummingbird.2ae09724.png";